import React, { Component } from 'react';
import { Glyphicon } from "react-bootstrap";

export class SortIndicator extends Component {
    render() {
        if (this.props.order === "ascending") {
            return <span className="sort-indicator">
                <Glyphicon glyph="chevron-up" />
                <Glyphicon className="text-muted" glyph="chevron-down" />
            </span>

        } 
        
        if (this.props.order === "descending") {
            return <span className="sort-indicator">
                <Glyphicon className="text-muted" glyph="chevron-up" />
                <Glyphicon glyph="chevron-down" />
            </span>
        }
        
        return <span className="sort-indicator">
            <Glyphicon className="text-muted" glyph="chevron-up" />
            <Glyphicon className="text-muted" glyph="chevron-down" />
        </span>
    }
}



// WEBPACK FOOTER //
// ./src/components/SortIndicator.js